import { render, staticRenderFns } from "./UpdateziliaoRight.vue?vue&type=template&id=5c1af069&scoped=true"
import script from "./UpdateziliaoRight.vue?vue&type=script&lang=js"
export * from "./UpdateziliaoRight.vue?vue&type=script&lang=js"
import style0 from "./UpdateziliaoRight.vue?vue&type=style&index=0&id=5c1af069&prod&lang=css"
import style1 from "./UpdateziliaoRight.vue?vue&type=style&index=1&id=5c1af069&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1af069",
  null
  
)

export default component.exports